export const toError = (value: unknown): Error => {
  if (value instanceof Error) {
    return value;
  }
  if (typeof value === 'string') {
    return new Error(value);
  }
  if (value && typeof value === 'object') {
    const message =
      'message' in value && typeof value.message === 'string'
        ? value.message
        : safeStringify(value);
    return new Error(message);
  }
  return new Error(String(value));
};

const safeStringify = (value: unknown): string => {
  try {
    return JSON.stringify(value) ?? String(value);
  } catch {
    return String(value);
  }
};
